import { render, staticRenderFns } from "./Static.vue?vue&type=template&id=690be6fc&scoped=true&"
import script from "./Static.vue?vue&type=script&lang=ts&"
export * from "./Static.vue?vue&type=script&lang=ts&"
import style0 from "./Static.vue?vue&type=style&index=0&id=690be6fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690be6fc",
  null
  
)

export default component.exports